// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--R2bpz","container":"footer-module--container--2Y5FL","redTape":"footer-module--red-tape--3pdeR"};